import { render, staticRenderFns } from "./index.vue?vue&type=template&id=079bffdb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=079bffdb&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=079bffdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.31_css-loader@6.11.0_webpack@5.93.0__lodash@4.17.21__2224vjmmlkuugiasgw4yfadix4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079bffdb",
  null
  
)

export default component.exports